import { constructionServices, engineeringServices } from '../../data/services';
import SectionHeading from '../ui/SectionHeading';
import ServiceCard from '../ui/ServiceCard';
import AnimatedSection from '../ui/AnimatedSection';
import Button from '../ui/Button';
import { ArrowRight } from 'lucide-react';

export default function ServicesPreview() {
  const previewServices = [
    ...constructionServices.slice(0, 4),
    ...engineeringServices.slice(0, 2),
  ];

  return (
    <section className="section-padding bg-charcoal-50">
      <div className="container-custom">
        <AnimatedSection>
          <SectionHeading
            subtitle="Our Services"
            title="Comprehensive Construction & Engineering Solutions"
            description="From general building construction to specialized engineering services, we deliver complete solutions for your project needs."
          />
        </AnimatedSection>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {previewServices.map((service, index) => (
            <AnimatedSection key={service.id} delay={index * 0.1}>
              <ServiceCard
                title={service.title}
                description={service.shortDescription}
                icon={service.icon}
                href={`/services#${service.id}`}
                compact
              />
            </AnimatedSection>
          ))}
        </div>

        <AnimatedSection delay={0.4} className="mt-12 text-center">
          <Button href="/services" variant="outline">
            View All Services
            <ArrowRight className="w-4 h-4 ml-2" />
          </Button>
        </AnimatedSection>
      </div>
    </section>
  );
}
